import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SearchIcon from '@mui/icons-material/Search';
import TransactionCommonModal from '../../common/TransactionCommonModal';
import { apiService } from '../../../../client/common/apiCallService';
import Loading from '../../common/Loading';
import { Store } from '@mui/icons-material';
import PropTypes from 'prop-types';
import TransferTransaction from './TransferTransaction';

const MerchantTransferModal = props => {
    const { open: propOpen, onClose: onCloseModal, row: selectedCurrency } = props;
    const apiUrl = useSelector(state => state.config.api_url);
    const clientData = useSelector(state => state.juno.clientData);

    const [open, setOpen] = useState(false);

    useEffect(() => {
        propOpen ? setOpen(true) : setOpen(false);
    }, [propOpen]);

    const [merchants, setMerchants] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [loading, setLoading] = useState(false);
    const [transferModal, setTransferModal] = useState(false);
    const [selectedMerchant, setSelectedMerchant] = useState(null);

    const fetchMerchants = async () => {
        setLoading(true);
        apiService(
            (window.location.hostname === 'localhost' ? apiUrl : '') + '/restapi/fetch-merchant',
            {
                clientObjId: clientData?._id,
                onlyLinked: true,
                page: 'all',
            },
            data => {
                setMerchants(data?.merchants || []);
                setLoading(false);
            },
            err => {
                console.error(err?.responseJSON?.err?.message || 'Error fetching merchants');
                setLoading(false);
            },
        );
    };

    useEffect(() => {
        if (open) {
            fetchMerchants();
            setSearchText('');
        }
    }, [open]);

    const filteredMerchants = merchants.filter(merchant =>
        merchant.merchantName.toLowerCase().includes(searchText.toLowerCase()),
    );
    const handleClose = () => {
        setOpen(false);
        onCloseModal();
    };
    return (
        <>
            <TransactionCommonModal
                open={open}
                onClose={handleClose}
                heading="Merchants"
                bottomButtonText=""
                showCloseIcon>
                <div className="flex flex-col gap-6 w-full">
                    <p className="text-sm font-medium text-balanceCard-manage text-uppercase">
                        To transfer funds to a merchant, please select one from the list below.
                    </p>

                    <div className="rounded-lg w-full p-2 border-none bg-card-bg flex items-center gap-2">
                        <input
                            type="text"
                            className="bg-card-bg  uppercase w-full !text-primary outline-none"
                            placeholder="Search Merchants"
                            data-e2e="search-merchant"
                            value={searchText}
                            onChange={e => setSearchText(e.target.value)}
                        />
                        <SearchIcon className="!text-primary" />
                    </div>

                    <div className="relative lg:h-[500px] h-[300px] custom-scrollbar">
                        {loading ? (
                            <div className="absolute inset-0 flex items-center justify-center z-10">
                                <Loading />
                            </div>
                        ) : filteredMerchants.length > 0 ? (
                            filteredMerchants.map((item, index) => (
                                <div
                                    key={index}
                                    className="flex items-center gap-3 rounded-lg my-2 p-3 !border !border-input-border cursor-pointer"
                                    onClick={() => {
                                        setSelectedMerchant(item);
                                        setTransferModal(true);
                                        setOpen(false);
                                    }}>
                                    {item.merchantLogo ? (
                                        <img
                                            src={item.merchantLogo}
                                            alt={`${item.merchantName} Logo`}
                                            className="rounded-full w-11 h-11"
                                        />
                                    ) : (
                                        <div className="w-11 h-11 !bg-secondary rounded-full flex justify-center items-center cursor-pointer ">
                                            <Store fontSize="medium" className="!text-primary" />
                                        </div>
                                    )}
                                    <h1
                                        className="!text-primary text-sm font-medium uppercase"
                                        data-e2e={item.merchantName}>
                                        {item.merchantName}
                                    </h1>
                                </div>
                            ))
                        ) : (
                            <div className="my-3 p-4 border border-[#EAECF0] rounded-lg text-center text-text">
                                No merchants found.
                            </div>
                        )}
                    </div>
                </div>
            </TransactionCommonModal>

            {transferModal && (
                <TransferTransaction
                    open={transferModal}
                    onClose={() => {
                        setTransferModal(false);
                        onCloseModal();
                    }}
                    selectedBalance={selectedCurrency}
                    selectedMerchant={selectedMerchant}
                />
            )}
        </>
    );
};

MerchantTransferModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    row: PropTypes.shape({
        _id: PropTypes.string,
    }).isRequired,
};

export default MerchantTransferModal;
